// extracted by mini-css-extract-plugin
export default {"Titulo":"not-found-page_Titulo__tfQ0G","Centro":"not-found-page_Centro__zTr3u"};